// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77a24b67] {\n  fill: #fff\n}\n.st107[data-v-77a24b67] {\n  fill: #f8a283\n}\n", ""]);
// Exports
module.exports = exports;
